
import * as React from 'react';
import { BasePageModel } from '@interface/base';
import { FrameType } from '@interface/frame';
import { getAgentPathPrefix } from '@lib/quick-func';
import Link from 'antd/lib/typography/Link';

export function sourceRender(data: BasePageModel, frameType: string): React.ReactNode {

  return data.inheritedFromCompositeName
    ? <Link href={`${getAgentPathPrefix()}/${frameType === FrameType.service ? 'service' : 'frame'}/${data.inheritedFromCompositeId}`} >Reuse</Link>
    : (data.isOverwrite ? 'Local+' : 'Local');
}
